<template>
  <div class="table">
    <CustomTable
      title="Список комнат в черновой"
      :rowsData="this.rowsData"
      :columns="this.shellRoomsColumns"
      :loading="isFetching"
      :show-search="true"
      :custom-body="true"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.room_type_id }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.room_type_name }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <div class="select" v-if="editPurposeMap[props.row.room_type_id]">
              <CustomSelect
                :options="purposeOptions"
                optionValueKey="room_purpose_id"
                optionLabelKey="room_purpose_name"
                :value="props.row.room_purpose_id"
                @change="(value) => onChangeRoomPurpose(value, props.row.room_type_id)"
                :clearable="false"
                :noLabel="true"
              />
              <CustomIcon 
                icon="close" 
                class="icon-cancel" 
                red
                title="Отменить редактирование" 
                @click="toggleEditPurpose(props.row.room_type_id, false)" 
              />
            </div>
            <div v-else class="purpose-display">
              <span>{{ props.row.room_purpose_name }}</span>
              <CustomIcon 
                icon="edit" 
                green
                class="icon-edit" 
                title="Редактировать назначение" 
                @click="toggleEditPurpose(props.row.room_type_id, true)" 
              />
            </div>
          </custom-table-cell>
          <!-- <custom-table-cell align="center" vertical-align="center">
            <CheckOrClose
              :value="props.row.is_active"
              title="Поменять значение"
              class="hover"
            />
            <PopupConfirm
              :loading="this.ceilingValLoading[props.row.room_type_id]"
              :approve="
                () =>
                  this.onCountCeiling(
                    props.row,
                    props.row.is_count_ceiling == 1 ? 0 : 1
                  )
              "
            />
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <CheckOrClose :value="props.row.is_active" />
          </custom-table-cell> -->
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomIcon from "@/components/common/CustomIcon";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CheckOrClose from "@/components/common/CheckOrClose";
import PopupConfirm from "@/components/common/PopupConfirm";
import {
  shellRoomsColumns,
  getShellRooms,
  getRoomPurposesFS,
  updRoomPurpose,
  updCountCeiling,
} from "@/views/ShellRooms/services";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";

export default {
  name: "ShellRooms",
  components: {
    CustomInput,
    CustomIcon,
    CustomTableCell,
    CustomTable,
    CustomSelect,
    CheckOrClose,
    PopupConfirm,
  },
  data() {
    return {
      rowsData: [],
      purposeOptions: [],
      shellRoomsColumns,
      isFetching: false,
      ceilingValLoading: {},
      editPurposeMap: {}, 
    };
  },
  mounted() {
    this.getData();
    this.getRoomPurposes();
  },
  methods: {
    async getData() {
      this.isFetching = true;
      const res = await getShellRooms();
      this.isFetching = false;
      if (!res) return;
      this.rowsData = res;
    },
    async getRoomPurposes() {
      const res = await getRoomPurposesFS();
      if (!res) return;
      this.purposeOptions = res;
    },
    async onChangeRoomPurpose(value, room_type_id) {
      const res = await updRoomPurpose({
        room_type_id,
        room_purpose_id: value,
      });
      if (!res) return;
      this.toggleEditPurpose(room_type_id, false);
      this.showSucceedSnackbar("Значение успешно изменено");
      this.getData();
    },
    // async onCountCeiling(row, value) {
    //   this.ceilingValLoading = {
    //     ...this.ceilingValLoading,
    //     [row.room_type_id]: true,
    //   };
    //   const res = await updCountCeiling({
    //     room_type_id: row.room_type_id,
    //     is_avail: value,
    //   });
    //   this.ceilingValLoading = {
    //     ...this.ceilingValLoading,
    //     [row.room_type_id]: false,
    //   };
    //   if (!res) return;
    //   this.getData();
    // },
    
    toggleEditPurpose(roomTypeId, isEdit) {
      // Если включаем редактирование, сначала сбрасываем все строки
      if (isEdit) {
        // Создаем новый объект с пустыми значениями
        this.editPurposeMap = {};
      }
      
      // Устанавливаем значение только для текущей строки
      this.editPurposeMap = {
        ...this.editPurposeMap,
        [roomTypeId]: isEdit
      };
    },
  },
  computed: {
    CeilingTitle(value) {
      return value === 1 ? "Не считать потолок" : "Считать потолок";
    },
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar };
  },
};
</script>

<style scoped lang="scss">
.table{
max-width: 600px;
}
.select {
  justify-self: center;
  display: flex;
  align-items: center;
}

.purpose-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.icon-edit, .icon-cancel {
  margin-left: 10px;
  font-size: 16px;
}

.hover {
  cursor: pointer;
}
.hover:hover {
  transform: scale(1.1);
  transition: all 0.3s ease;
}
</style>
